<template>
  <div class="page-container">
    <Sidebar />
    <div class="main-content">
      <AdminTable :apiEndpoint="'/api/admin/industry-news'" :columns="columns" :filters="filters" :formFields="formFields" title="行业资讯" />
    </div>
  </div>
</template>
<script>
import Sidebar from '../components/Sidebar.vue'
import AdminTable from '@/components/AdminTable.vue'
export default { name: 'IndustryNewsList', components: { Sidebar, AdminTable },
  data() { return {
    columns: [{ key: 'id', label: 'ID' }, { key: 'title', label: '标题' }, { key: 'source', label: '来源' }, { key: 'created_at', label: '时间', type: 'date' }],
    filters: [], formFields: [{ key: 'title', label: '标题', type: 'text', required: true }, { key: 'source', label: '来源', type: 'text', required: true }, { key: 'url', label: '原文链接', type: 'text' }]
  } }
}
</script>
<style scoped>
.page-container { display: flex; min-height: 100vh; background: #f5f5f5; }
.main-content { flex: 1; margin-left: 260px; padding: 30px; }
</style>
